import { useCallback, useMemo } from 'react';

import type { RelevancyFeedOptions } from '../types';
import { GotxClassification } from '../types';

import { language } from '@utilities/browser';

const classificationMap: Record<GotxClassification, { apptype: string; gamesubtype: string }> = {
  [GotxClassification.GoalOfTheTournament]: { apptype: 'gott', gamesubtype: 'TOURNAMENT' },
  [GotxClassification.GoalOfTheWeek]: { apptype: 'gotw', gamesubtype: 'MATCHDAY' },
  [GotxClassification.GoalOfTheMatchday]: { apptype: 'gotw', gamesubtype: 'MATCHDAY' },
  [GotxClassification.GoalOfTheDay]: { apptype: 'gotd', gamesubtype: 'DAY' },
  [GotxClassification.GoalOfTheCompetition]: { apptype: 'gotc', gamesubtype: 'COMPETITION' },
  [GotxClassification.GoalOfTheRound]: { apptype: 'gotr', gamesubtype: 'ROUND' },
  [GotxClassification.PlayerOfTheWeek]: { apptype: 'potw', gamesubtype: null },
};

export const usePollGame = (options: RelevancyFeedOptions, section?: string) => {
  const mapPollGame = useCallback(
    (classification: GotxClassification) => {
      const { apptype = '', gamesubtype = '' } = classificationMap[classification] || {};
      const polltype = apptype === 'potw' ? apptype : 'got';

      return {
        apptype,
        polltype,
        gamesubtype,
        element: 'card-component',
        integrationType: 'WEBCOMP',
        language,
        source: options.webComponentUrl,
      };
    },
    [options.webComponentUrl],
  );

  const isPollGame = useMemo(() => !!classificationMap[section!], [section]);

  return { mapPollGame, isPollGame };
};
